"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryBox = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const SummaryBoxStyled = styled_components_1.default.div `
	width: 100%;

	.status-summary-card {
		border: 1px solid var(--color-grey-c, #e6e8ed);
		border-radius: 12px;
		padding: ${props => (props.$isMobile ? '16px' : '20px 24px')};
		display: flex;
		flex-direction: column;
		gap: 12px;
		background: #fff;
		min-width: 0;
	}

	.summary-title {
		color: var(--color-black, #101010);
		font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => props.$isMobile || props.$isTablet
    ? 'var(--b3-font-size, 16px)'
    : 'var(--b1-font-size, 20px)'};
		line-height: ${props => props.$isMobile || props.$isTablet
    ? 'var(--b3-line-height, 32px)'
    : 'var(--b1-line-height, 42px)'};
		font-weight: var(--b1-font-weight, 400);
	}

	.summary-sub {
		color: var(--color-grey, #666666);
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => (props.$isMobile ? '13px' : '16px')};
		line-height: 150%;
		letter-spacing: -0.02em;
		word-break: keep-all;
	}

	.summary-sub .summary-first-metric {
		margin-left: 8px;
		display: inline-block;
	}

	.summary-rate {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.summary-percent {
		min-width: ${props => (props.$isMobile ? '72px' : '90px')};
		color: var(--color-black, #101010);
		font-family: var(--h2-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => props.$isMobile || props.$isTablet
    ? 'var(--h4-font-size, 20px)'
    : 'var(--h2-font-size, 32px)'};
		line-height: ${props => props.$isMobile || props.$isTablet
    ? 'var(--h4-line-height, 32px)'
    : 'var(--h2-line-height, 46px)'};
		font-weight: var(--h2-font-weight, 700);
	}
`;
exports.SummaryBox = react_1.default.memo(({ title, color, percentage, totalCount, done, subTitle, forceDesktop = false, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const effectiveIsMobile = forceDesktop ? false : isMobile;
    const effectiveIsTablet = forceDesktop ? false : isTablet;
    const effectiveIsDesktop = forceDesktop ? true : isDesktop;
    const percentValue = Number.isFinite(percentage) ? Math.max(0, percentage) : 0;
    return (react_1.default.createElement(SummaryBoxStyled, { "$isMobile": effectiveIsMobile, "$isTablet": effectiveIsTablet, "$isDesktop": effectiveIsDesktop },
        react_1.default.createElement("div", { className: "status-summary-card" },
            react_1.default.createElement("div", { className: "summary-title" }, title),
            react_1.default.createElement("div", { className: "summary-sub" }, subTitle),
            react_1.default.createElement("div", { className: "summary-rate" },
                react_1.default.createElement("div", { className: "summary-percent" },
                    Math.round(percentValue),
                    "%"),
                react_1.default.createElement(common_1.SimpleBarGraph, { value: done, max: totalCount, fillColor: color, trackColor: "#e5e6ea", height: effectiveIsMobile ? 20 : 24, borderRadius: 0 })))));
});
